import { Component, Input, OnInit } from '@angular/core';
import { log } from 'console';
import { BaseComponent } from '../../base/base.component';

@Component({
  selector: 'app-claro-big-label',
  templateUrl: './claro-big-label.component.html',
  styleUrls: ['./claro-big-label.component.scss']
})
export class ClaroBigLabelComponent extends BaseComponent implements OnInit {
  @Input() iconPath : string;
  @Input() colorScheme : string;
  @Input() labelText: string;
  @Input() height: string;
  @Input() width: string;
  @Input() fontSize: string;
  @Input() iconFontSize: string = '40px';

  constructor() {
    super();
   }

  ngOnInit(): void {
    super.ngOnInit();
    this.enforceTextSize();
  }

  enforceTextSize(): void{
    if (this.labelText.length > 14){
      this.fontSize = '15px';
    }

    // console.log(`in CBL enforceTextSize label text is ${this.labelText} length is ${this.labelText.length} font size is ${this.fontSize}`);
  }

}
